import React from 'react';
import Link from 'gatsby-link';
import { navigate } from 'gatsby';
import styled from 'styled-components';
import OfferCardMenuPage from '../../Offers/OfferDetails/components/OfferCardMenuPage';
import MenuArrow from './MenuArrow';
import appConfig from '../../../../app-config';
import LoyaltyCardContainer from '../../Loyalty/LoyaltyCardContainer';

const Wrapper = styled.div`
  margin-bottom: 45px;
  margin-top: 24px;
  display: grid;
`;

const Arrow = styled.img`
  width: 45px;
`;

const ViewRewardsText = styled(Link)`
  color: ${(props) => props.theme.clickableTextColor};
  text-decoration: none;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02px;
  margin-top: 13px;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
    transition: all 0.25s ease;
  }

  @media (max-width: 500px) {
    margin-top: 0;
    align-content: center;
  }

  @media (min-width: 1100px) and (max-width: 1280px) {
    margin-top: 0;
    align-content: center;
  }

  @media (min-width: 769px) and (max-width: 900px) {
    margin-top: 0;
    align-content: center;
  }
`;

const AuthDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  @media (max-width: 500px) {
    grid-auto-flow: row;
  }

  @media (min-width: 1100px) and (max-width: 1280px) {
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: row;
  }

  @media (min-width: 769px) and (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: row;
  }
`;

const ViewAllWrapper = styled.div`
  position: relative;

  @media (max-width: 500px) {
    margin-bottom: 33px;
  }

  @media (min-width: 1100px) and (max-width: 1280px) {
    margin-bottom: 33px;
  }

  @media (min-width: 769px) and (max-width: 900px) {
    margin-bottom: 33px;
  }
`;

const ViewAllDiv = styled.div`
  vertical-align: middle;
  top: 50%;
  transform: translate(0, -50%);
  position: absolute;
  width: 70px;

  @media (max-width: 500px) {
    margin-top: 26px;
    width: 200px;
    display: flex;
    justify-content: space-evenly;
  }

  @media (min-width: 1100px) and (max-width: 1280px) {
    margin-top: 26px;
    width: 200px;
    display: flex;
    justify-content: space-evenly;
  }

  @media (min-width: 769px) and (max-width: 900px) {
    margin-top: 26px;
    width: 200px;
    display: flex;
    justify-content: space-evenly;
  }
`;

const MenuRewards = ({ offers, currentPointsBalance }) => {
  // let offers = [];
  if (appConfig.isLoyaltyEnabled) {
    if (appConfig.isOffersEnabled && offers.length) {
      return (
        <Wrapper>
          <AuthDiv>
            <LoyaltyCardContainer layoutStyle='menu' />
            <OfferCardMenuPage
              offer={offers[0]}
              mediaQueryMaxWidth='1550px'
              currentPointsBalance={currentPointsBalance}
            />
            <ViewAllWrapper>
              <ViewAllDiv onClick={() => navigate('/offers')}>
                <MenuArrow />
                <ViewRewardsText>
                  <p id='MenuRewards-ViewAll'>View All Rewards</p>
                </ViewRewardsText>
              </ViewAllDiv>
            </ViewAllWrapper>
          </AuthDiv>
        </Wrapper>
      );
    } else {
      return (
        <Wrapper>
          <AuthDiv>
            <LoyaltyCardContainer layoutStyle='offer' />
          </AuthDiv>
        </Wrapper>
      );
    }
  } else if (appConfig.isOffersEnabled && offers.length) {
    return (
      <Wrapper>
        <AuthDiv>
          <OfferCardMenuPage
            offer={offers[0]}
            currentPointsBalance={currentPointsBalance}
          />
          {offers.length > 1 ? (
            <OfferCardMenuPage
              offer={offers[1]}
              currentPointsBalance={currentPointsBalance}
            />
          ) : null}
          <div style={{ position: 'relative' }}>
            <ViewAllDiv
              style={{
                verticalAlign: 'middle',
                top: '50%',
                transform: 'translate(0, -50%)',
                position: 'absolute',
              }}
              onClick={() => navigate('/offers')}
            >
              <MenuArrow />
              <ViewRewardsText>
                <p id='MenuRewards-ViewAll'>View All</p>
                <p id='MenuRewards-Rewards'>Rewards</p>
              </ViewRewardsText>
            </ViewAllDiv>
          </div>
        </AuthDiv>
      </Wrapper>
    );
  } else {
    return <div />;
  }
};

export default MenuRewards;
